import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { useDeviceType } from '../../hooks/useDeviceType.ts';

import Page404 from '../../pages/Auth/CheckEmail/Page404';

import {
    selectIsBtnLeftPanelEnabled,
    selectIsBtnMinimapEnabled,

    selectIsBtnExportImageEnabled,
    selectDiagramDetails,
} from '../../redux/diagram/diagram.selectors';

import { selectIsDiagramCanvasDeleted, selectIsDiagramCanvasNotFound } from '../../redux/main/main.selectors';

import {
    mainCanvasStarted,
    clearDiagramErrors,
    // loadNewProject,
    // loadSampleProjectDetails,
} from '../../redux/main/main.actions';
import {
    canvasStarted,
    fetchDiagram,
    // loadSampleProjectData,
    clearDiagramDetails,
} from '../../redux/diagram/diagram.actions';

import LoaderBar from '../../components/Loaders/LoaderBar/LoaderBar';

import DraggableTable from '../../components/DraggableElements/DraggableTable/DraggableTable';

import ControlsLeft from '../../components/Controls/ControlsLeft/ControlsLeft';
import ControlsBottom from '../../components/Controls/ControlsBottom/ControlsBottom';
import ControlsTopRight from '../../components/Controls/ControlsTopRight/ControlsTopRight';
import ControlsTopLeft from '../../components/Controls/ControlsTopLeft/ControlsTopLeft';

import PanelLeft from '../../components/Panels/PanelLeft/PanelLeft';

import ModalFeedback from '../../components/Modals/ModalFeedback/ModalFeedback';
import ModalFeedbackThanks from '../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks.jsx';

import ModalKeyboardShortcuts from '../../components/Modals/ModalKeyboardShortcuts/ModalKeyboardShortcuts';

import ModalPricingPlanLimitCanvas from '../../components/Modals/ModalPricingPlanLimitCanvas/ModalPricingPlanLimitCanvas.jsx';
import ModalPricingPlanLimitMaxCanvas from '../../components/Modals/ModalPricingPlanLimitMaxCanvas/ModalPricingPlanLimitMaxCanvas.jsx';
import ModalPricingPlanUpgrade from '../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';


import Minimap from '../../components/Minimap/Minimap';
import Canvas from '../../components/Canvas/Canvas';

import './Diagram.scss';
import NotifyMessage from '../../components/NotifyMessage/NotifyMessage';
import Notify from '../../components/Notify/Notify';
import NotifyButtonAI from '../../components/NotifyButtonAI/NotifyButtonAI';


import ModalDiagramDetails from '../../components/Modals/ModalDiagramDetails/ModalDiagramDetails';
import ModalDiagramShare from '../../components/Modals/ModalDiagramShare/ModalDiagramShare';
import ModalDiagramClone from '../../components/Modals/ModalDiagramClone/ModalDiagramClone';
import ModalDiagramDelete from '../../components/Modals/ModalDiagramDelete/ModalDiagramDelete';
import ModalDiagramDeleteSoft from '../../components/Modals/ModalDiagramDeleteSoft/ModalDiagramDeleteSoft';
import ModalDiagramCreate from '../../components/Modals/ModalDiagramCreate/ModalDiagramCreate';
import ModalDiagramCreateNew from '../../components/Modals/ModalDiagramCreateNew/ModalDiagramCreateNew';

import ModalDiagramExportSQL from '../../components/Modals/ModalDiagramExportSQL/ModalDiagramExportSQL.jsx';
import ModalLanguages from '../../components/Modals/ModalLanguages/ModalLanguages';
import ModalWorkspaceCreate from '../../components/Modals/ModalWorkspaceCreate/ModalWorkspaceCreate.jsx';


const Diagram = ({ isNew = false }) => {
    const { diagramId } = useParams();
    const history = useHistory();

    const { isDesktop } = useDeviceType(); // mobile/tablet => false

    const isBtnLeftPanelEnabled = useSelector(selectIsBtnLeftPanelEnabled);
    const isBtnMinimapEnabled = useSelector(selectIsBtnMinimapEnabled);

    const isBtnExportImageEnabled = useSelector(selectIsBtnExportImageEnabled);

    const isDiagramCanvasDeleted = useSelector(selectIsDiagramCanvasDeleted);
    const isDiagramCanvasNotFound = useSelector(selectIsDiagramCanvasNotFound);

    const diagramDetails = useSelector(selectDiagramDetails);

    const loadingTimerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isNew) {
            // dispatch(loadNewProject());
            // } else if (isLoadSampleProject) {
            //     dispatch(loadSampleProjectDetails());
            //     dispatch(loadSampleProjectData());
        } else {
            dispatch(fetchDiagram(diagramId));
        }
        dispatch(canvasStarted());
        dispatch(mainCanvasStarted());

        return () => {
            dispatch(clearDiagramErrors());
            dispatch(clearDiagramDetails());
        };

    }, [diagramId, dispatch]);

    useEffect(() => {
        if (isDiagramCanvasDeleted) {
            setTimeout(() => {
                history.push(`/diagrams`);
            }, 300);

        }
    }, [isDiagramCanvasDeleted, history]);

    useEffect(() => {
        // set is page loading
        setIsLoading(true);

        // set timeout on page loading
        clearTimeout(loadingTimerRef.current);
        loadingTimerRef.current = setTimeout(() => {
            setIsLoading(false);
        }, 450);
        return () => { };
    }, []);

    useEffect(() => {
        if (isLoading || !diagramDetails) {
            document.title = 'Loading diagram...';
        } else {
            document.title = `${diagramDetails.title || ''} - DB Design`;
        }
    }, [isLoading, diagramDetails]);

    const canvasRef = useRef(null);
    const minimapRef = useRef(null);

    if (isDiagramCanvasNotFound) return <Page404 type="diagram" />;
    if (!isNew && !diagramDetails) return null;

    return (
        <div className="Diagram">
            <div className="panel-panel">
                <div className="panel-board">
                    <DraggableTable />
                    <ControlsTopLeft />
                    {isDesktop ? <ControlsTopRight /> : ''}
                    {true ? <ControlsLeft /> : ''}
                    <ControlsBottom canvasRef={canvasRef} minimapRef={minimapRef} />

                    <PanelLeft isVisible={isBtnLeftPanelEnabled && !isBtnExportImageEnabled} />

                    <ModalKeyboardShortcuts />
                    <ModalLanguages />

                    <ModalFeedback />
                    <ModalFeedbackThanks />

                    <ModalDiagramDetails />
                    <ModalDiagramShare />
                    <ModalDiagramClone />
                    <ModalDiagramDeleteSoft />
                    <ModalDiagramDelete />

                    <ModalPricingPlanLimitCanvas />
                    <ModalPricingPlanLimitMaxCanvas />
                    <ModalPricingPlanUpgrade />

                    <ModalDiagramCreate />
                    <ModalDiagramCreateNew />
                    <ModalDiagramExportSQL />

                    <ModalWorkspaceCreate />

                    <Minimap ref={minimapRef} isOpen={isBtnMinimapEnabled && !isBtnExportImageEnabled} />

                    {/* <NotifyMessage /> */}
                    {/* <NotifyButtonAI /> */}
                    <Notify viewType='canvas' />

                    {Math.random() === 12 && <LoaderBar isLoading={isLoading} />}
                    <Canvas
                        isLoading={isLoading}
                        ref={canvasRef}
                        minimapRef={minimapRef}
                    />
                </div>
            </div>
        </div>
    );
};

export default Diagram;
